<p-dialog [visible]="true" [closable]="false" [modal]="true" [baseZIndex]="data.baseZIndex" [style]="data.dialogStyle"
    (onShow)="onDialogShow()">
    <ng-template #header>
        <div class="button-bar">
            <span>
                <ef-status-icon [status]="data.maxStatus" [message]="data.dialogText"></ef-status-icon>
            </span>
            <span [innerHTML]="data.headerText">Are you sure?</span>
        </div>
    </ng-template>
    <div [innerHTML]="data.dialogText" class="dialog-text"></div>
    <ng-template #footer >
        <form #confirmTemplate>
            <mat-dialog-actions>
                <button *ngIf="data.showOk" pButton [class]="data.okClass" [mat-dialog-close]="true"
                    [label]="data.okText"></button>
                <button *ngIf="data.showCancel" pButton [class]="data.cancelClass" [mat-dialog-close]="false"
                    cdkFocusInitial [label]="data.cancelText"></button>
            </mat-dialog-actions>
        </form>
    </ng-template>
</p-dialog>
